import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";

@Component({
    selector: "app-footer",
    templateUrl: "./app.footer.component.html",
})
export class AppFooterComponent implements OnInit {
    mscvpRoleId: any;
    backendConfig: any;
    constructor(
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private router: Router
    ) {}

    userName = "";
    mscvpRole = "";
    userId = "";
    UserDetails: any;
    date=new Date();
    year=this.date.getFullYear();

    ngOnInit() {
        this.UserDetails = this.session.retrieve("UserDetails");
        this.backendConfig = this.session.retrieve("backend_config");
        // console.log( this.backendConfig,"=============");        
        this.userName = this.UserDetails === null ? "" : this.UserDetails.userName;
        this.mscvpRole = this.UserDetails === null ? "" : this.UserDetails.mscvpRole;
        this.userId = this.UserDetails === null ? "" : this.UserDetails.userId;
        this.mscvpRoleId = this.UserDetails === null ? "" : this.UserDetails.roleId;
        
    }

    loginuserinfo() {
        if(this.mscvpRoleId ===2||this.mscvpRoleId ===3||this.mscvpRoleId ===6||this.mscvpRoleId ===7){
            this.router.navigate(["/mscvp/m-doc-repository"]);
        }
        else if(this.mscvpRoleId ===4||this.mscvpRoleId ===5){
            this.router.navigate(["/mscvp/sfgRepo"]);
        }
        else {
            this.router.navigate(["/mscvp/profile"]);
        } 
    }
}
